/* eslint-disable react/no-unknown-property */
import { useTranslation } from '@pypestream/translations';
import type { FC } from 'react';

import { embedTypesList } from './embeds';

/**
 * Says in a bot bubble that the reply carried embeds (a slider, a date
 * picker…) which Validate cannot draw. The sentence is one translated key with
 * the type list interpolated. Plain text, no design-system imports,
 * so it can be rendered under jsdom.
 */
export const EmbedNote: FC<{ types: string[] }> = ({ types }) => {
  const [t] = useTranslation();
  if (!types.length) return null;
  return (
    <div
      className="c-validate-embed"
      test-id="bobcat-validate-embed"
      role="note"
    >
      {String(
        t('pro-studio/common:validateEmbed.note', {
          types: embedTypesList(types),
        })
      )}
    </div>
  );
};
